import React, { FC } from 'react';
import { MicroFrontend, SpecificMicroFrontendProps } from '../../core';
import { constants } from './constants';

export type EfficiencyMicroFrontendProps = SpecificMicroFrontendProps;

export type TrendGraphMicroComponentProps = SpecificMicroFrontendProps & {
  stationId: number;
  variableId: number;
  startAt: string;
  endAt: string;
  isMobile: boolean;
  title?: string;
  company?: { name: string; timezone: string; country?: string };
  onTrendChartUpdated?: (image: string | null) => void;
};

export const EfficiencyMicroFrontend: FC<EfficiencyMicroFrontendProps> = ({
  entryPointUrl,
  isAppMobile,
  isMobile,
  isTablet,
  isSmartTV,
  ...props
}) => {
  const exposedPath = isAppMobile ? constants.MFE_MOBILE_EXPOSED_PATH : constants.MFE_EXPOSED_PATH;

  return (
    <MicroFrontend
      entryPointUrl={entryPointUrl}
      name={constants.MFE_EFFICIENCY_NAME}
      exposedPath={exposedPath}
      isAppMobile={isAppMobile}
      isMobile={isMobile}
      isTablet={isTablet}
      isSmartTV={isSmartTV}
      {...props}
    />
  );
};

export const TrendGraph: FC<TrendGraphMicroComponentProps> = ({ entryPointUrl, ...props }) => {
  return (
    <MicroFrontend
      entryPointUrl={entryPointUrl}
      name={constants.MFE_EFFICIENCY_NAME}
      exposedPath={constants.TREND_GRAPH_EXPOSED_PATH}
      {...props}
    />
  );
};
